"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("./ajaxLoader.scss");
const react_redux_1 = require("react-redux");
const AjaxLoader = (props) => {
    const loader = react_1.createRef();
    const { preloader } = props;
    react_1.useEffect(() => {
        heightFixer();
    });
    const heightFixer = () => {
        if (loader.current) {
            const elem = loader.current;
            const loader_wrapper = loader.current.parentElement;
            loader_wrapper.style.position = 'relative';
            let scrollTop = window.scrollY;
            if (window.innerWidth <= 768) {
                scrollTop -= 130;
            }
            const scrollBottom = scrollTop + window.innerHeight;
            const loaderWrapperTop = loader_wrapper.offsetTop;
            const loaderWrapperBottom = loaderWrapperTop + loader_wrapper.offsetHeight;
            const visibleTop = loaderWrapperTop < scrollTop ? scrollTop : loaderWrapperTop;
            const visibleBottom = loaderWrapperBottom > scrollBottom ? scrollBottom : loaderWrapperBottom;
            let visibleHeight = visibleBottom - visibleTop;
            if (scrollTop >= loaderWrapperTop) {
                let loaderTopPosition = (scrollTop - loaderWrapperTop - 2);
                elem.style.top = loaderTopPosition + 'px';
            }
            else {
                elem.style.top = 0 + "px";
            }
            elem.style.height = visibleHeight + "px";
        }
    };
    document.getElementsByTagName('body')[0].onscroll = () => heightFixer();
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("div", { ref: loader, className: `v2-ajax-loader ${preloader.isAjaxLoading ? 'visible' : 'hidden'}` })));
};
const mapStateToProps = (state) => {
    const { preloader } = state;
    return {
        preloader
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(AjaxLoader);
